import { ImovelType } from "../../../shared/types/imoveis.type";
import { formatDatetime } from "../../../shared/utils/utils";
import dashboardStore from "../../../store/dashboardStore";
import { EmptyData } from "../../EmptyData";
import CardTopItem from "../CardTopItem";
import { Card, Table, TitleCard } from "./styles";

export function CardTop003() {
    const { imoveisPublicados } = dashboardStore().imoveisInfo;

    const maxImoveis = 10;
    const imoveis = imoveisPublicados.slice(0, maxImoveis);

    return (
        <Card>
            <TitleCard>Últimos imóveis atualizados</TitleCard>
            {
                imoveis?.length ?
                <>
                    <Table>
                        <thead>
                            <tr>
                                <th>CÓDIGO</th>
                                <th>ENDEREÇO</th>
                                <th>ATUALIZADO</th>
                                <th>LINK</th>
                            </tr>
                        </thead>
                        <tbody>
                            {
                                imoveis?.map((imovel) => {
                                    const atualizado = formatDatetime(
                                        imovel.dataAtualizacao, {includeTime: false}
                                    );
                                    return (
                                        <CardTopItem
                                            code={imovel.codigo}
                                            value={imovel?.endereco}
                                            atualizado={atualizado}
                                            tipo={ImovelType.IMOVEL}
                                            key={imovel.id}
                                        />
                                    );
                                })
                            }
                        </tbody>
                    </Table>
                </> : <EmptyData />
            }
        </Card>
    );
}
